// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__A7b_n","inverse":"button_inverse___IA_e","disabled":"button_disabled__ggLuh"};